<template>
  <div class="ap-index-numbersearch">
    <div class="clearfix">
      <div class="float-left clearfix number-wrap">
        <div class="float-left oe-search">
          <div class="item-title">原厂零件编号 OE</div>
          <div class="item-cont">
            <textarea rows="5" style="max-height:120px;" class="form-control" placeholder="每个OE号码单独一行" v-model="oeNumber"></textarea>
            <div style="margin:20px 0 30px">
              <button class="ap-btn-darkred ap-btn-red-hover1 ap-btn-middle" @click="oeSearch">查询</button>
            </div>
            <div>
              所输号码将被自动去除连接符或空格。比如：
              <br />查询1K0.615.301 D将自动当作1K0615301D
            </div>
          </div>
        </div>
        <div class="float-left aftermarket-search">
          <div class="item-title">后市场品牌零件编号</div>
          <div class="item-cont">
            <textarea rows="5" style="max-height:120px;" class="form-control" placeholder="每个产品号码单独一行" v-model="cmpNumber"></textarea>
            <div style="margin:20px 0 30px">
              <button class="ap-btn-darkred ap-btn-red-hover1 ap-btn-middle" @click="cmpSearch">查询</button>
            </div>
          </div>
        </div>
      </div>
      <div class="float-right news">
        <div class="item-title">交易动态</div>
        <div class="item-cont">
          <ul class="roll-wrap">
            <li class="roll-item" v-for="(it,idx) in rollData" :key="idx + Math.random()">
              <div class="org-name">{{ it.name }}</div>
              <div class="price">￥{{ it.price | toMoney }}</div>
              <div class="time">{{ it.time }}</div>
            </li>
            <li class="roll-item" v-for="(it,idx) in rollData.slice(0,7)" :key="idx + Math.random()">
              <div class="org-name">{{ it.name }}</div>
              <div class="price">￥{{ it.price | toMoney }}</div>
              <div class="time">{{ it.time }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="brands">
      <div class="item-title clearfix">
        <span>已上线的制造商品牌</span>
        <button class="ap-btn float-right" style="padding:5px 18px;margin-top:-5px;">
          <strong>如何加入？</strong>
        </button>
      </div>
      <div class="item-cont" v-loading="loading" style="min-height:213px">
        <div class="brand-items clearfix">
          <div class="brand-item" v-for="it in records" :key="it.id">
            <div class="img-wrap">
              <img class="img" :src="getImgUrl(it.logoUri)" alt />
            </div>
            <div class="text-truncate">{{it.flName}} {{it.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown header-nav-dropdown his-wrap">
      <div class="drop-down tit" data-toggle="dropdown" @click="getHistory">
        <img src="@assets/icons/refresh.png" />
        <span class="text">号码查询历史记录</span>
      </div>
      <div class="dropdown-arrow"></div>
      <div class="dropdown-menu" @click.stop="0">
        <ul>
          <li class="item" v-for="it in history" :key="it.id" @click.stop="goToHistory(it)">
            <strong v-if="it.type=='OEM'" class="type" style="background:#099">OE</strong>
            <strong v-if="it.type=='CMP'" class="type" style="background:#F90">品牌</strong>
            <span class="text" v-html="formatNum(it.detail)" v-if="it.count=='single'"></span>
            <span class="text" v-html="formatNum(it.detail)" v-if="it.count=='multi'"></span>
          </li>
          <li v-if="!history.length" class="clear">无历史记录！</li>
          <li v-else class="item clear" @click.stop="clearHistory">
            <i class="fas fa-trash-alt"></i>&nbsp;清空历史记录！
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { strToLineOne } from "@common/utils";
import * as localStorage from "@common/localStorage";

export default {
  data() {
    return {
      oeNumber: "",
      cmpNumber: "",
      records: [],
      showHistory: true,
      history: [],
      loading: false,
      rollData: []
    };
  },
  created() {
    let i = 1;
    while (i <= 20) {
      this.rollData.push({
        name: "广州梅斯汽配（斯柯达） " + i,
        price: "10160",
        time: "14:24:38"
      });
      i++;
    }
    this.getData();
    document.title = "51 AUTOPARTS 汽配供应链首页";
  },
  methods: {
    getData() {
      this.loading = true;
      this.$post("/dmhs/brands/select")
        .then(res => {
          this.loading = false;
          this.records = res;
        })
        .catch(err => {});
    },
    formatNum(arr) {
      let str = " ";
      arr.forEach(it => {
        str = str + it + "&nbsp;&nbsp;&nbsp;";
      });
      return str;
    },
    getHistory() {
      this.history = localStorage.read("_numberSearchHistory") || [];
    },
    clearHistory() {
      this.history = [];
      localStorage.remove("_numberSearchHistory");
    },
    goToHistory(it) {
      if (it.count == "single") {
        let routeData = this.$router.resolve({
          path: "/oesearch/single",
          query: {
            oeNumber: it.detail[0],
            type: it.type
          }
        });
        window.open(routeData.href, "_blank");
      } else if (it.count == "multi") {
        localStorage.write("OENumbers", it.detail);
        localStorage.write("type", it.type);
        window.open("#/oesearch/multi", "_blank");
      }
    },
    oeSearch() {
      let nums = strToLineOne(this.oeNumber);
      this.numSearch({ type: "OEM", ns: nums });
    },
    cmpSearch() {
      let nums = strToLineOne(this.cmpNumber);
      this.numSearch({ type: "CMP", ns: nums });
    },
    numSearch(args) {
      let numbers = args.ns;
      if (!numbers.length) return;
      let arr = localStorage.read("_numberSearchHistory") || [];
      if (numbers.length == 1) {
        let routeData = this.$router.resolve({
          path: "/oesearch/single",
          query: {
            oeNumber: numbers[0],
            type: args.type
          }
        });
        let id = "single" + args.type + numbers.toString();
        let index = arr.findIndex(x => x.id == id);
        if (index > -1) {
          let temp = arr.splice(index, 1);
          arr.unshift(temp[0]);
        } else {
          arr.unshift({
            id,
            count: "single",
            type: args.type,
            detail: numbers
          });
        }
        if (arr.length > 20) arr.pop();
        localStorage.write("_numberSearchHistory", arr);

        window.open(routeData.href, "_blank");
      } else if (numbers.length > 1) {
        let id = "multi" + args.type + numbers.toString();
        let index = arr.findIndex(x => x.id == id);
        if (index > -1) {
          let temp = arr.splice(index, 1);
          arr.unshift(temp[0]);
        } else {
          arr.unshift({
            id,
            count: "multi",
            type: args.type,
            detail: numbers
          });
        }
        if (arr.length > 20) arr.pop();
        localStorage.write("_numberSearchHistory", arr);

        localStorage.write("OENumbers", numbers);
        localStorage.write("type", args.type);
        window.open("#/oesearch/multi", "_blank");
      }
    }
  }
};
</script>

<style lang="less">
.ap-index-numbersearch {
  position: relative;
  font-size: 14px;
  .item-title {
    height: 54px;
    padding: 16px 30px;
    border-bottom: 1px solid #e4e4e4;
    font-weight: bold;
  }
  .item-cont {
    overflow: hidden;
    height: 280px;
  }
  .oe-search,
  .aftermarket-search {
    width: 50%;
    .item-cont {
      padding: 20px 28px 0;
      background: #f6f7f9;
      font-size: 12px;
      button {
        font-size: 12px;
      }
    }
  }
  .oe-search {
    .item-title,
    .item-cont {
      border-right: 1px solid #e4e4e4;
    }
  }
  .number-wrap,
  .news,
  .brands {
    border: 1px solid #e4e4e4;
  }
  .news {
    width: 580px;
  }
  .number-wrap {
    width: 670px;
  }
  .brands {
    margin-top: 20px;
    .item-cont {
      padding-top: 28px;
      height: auto;
      background: #f6f7f9;
      .brand-items {
        .brand-item {
          float: left;
          width: 177px;
          text-align: center;
          background: #fff;
          text-align: center;
          margin-left: 28px;
          margin-bottom: 28px;
          .img-wrap {
            display: inline-block;
            margin: 14px 0;
            width: 136px;
            height: 96px;
            .img {
              width: 100%;
              height: 100%;
            }
          }
          .text-truncate {
            padding-bottom: 12px;
          }
        }
      }
    }
  }
  .his-wrap {
    position: absolute;
    right: 0;
    top: 0;
    .tit {
      box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.4);
      background: #fff;
      position: absolute;
      right: 20px;
      top: -70px;
      width: 175px;
      height: 38px;
      border-radius: 19px;
      border: 1px solid #ccc;
      padding: 6px 18px;
      cursor: pointer;
      .text {
        vertical-align: middle;
        margin-left: 10px;
        font-size: 12px;
      }
    }
    .dropdown-arrow {
      left: -100px;
      top: -10px;
    }
    .dropdown-menu {
      padding: 10px;
      overflow: auto;
      left: -450px !important;
      margin: 0;
      width: 450px;
      height: 280px;
      .item {
        font-size: 12px;
        display: flex;
        padding: 4px;
        cursor: pointer;
        &:hover {
          background: #f6f7f9;
          font-weight: bold;
        }
        .type {
          width: 32px;
          height: 20px;
          color: #fff;
          text-align: center;
          padding: 1px 3px;
          border-radius: 3px;
        }
        .text {
          color: #000;
          margin-left: 10px;
        }
      }
      .clear {
        display: block;
        text-align: center;
        padding: 8px;
      }
    }
  }
  .roll-wrap {
    font-size: 12px;
    padding: 0 20px;
    animation: 15s loop linear infinite;
    .roll-item {
      display: flex;
      padding: 10px;
      border-bottom: 1px solid #efefef;
      height: 40px;
      .org-name {
        flex: 3;
      }
      .price {
        color: #e74e52;
        font-weight: bolder;
        text-align: right;
        flex: 1;
      }
      .time {
        color: #666;
        text-align: right;
        flex: 1;
      }
    }
    @keyframes loop {
      0% {
        transform: translateY(0%);
      }
      100% {
        transform: translateY(-800px);
      }
    }
  }
}
</style>